/* global $ */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "hiddenId", "submitBtn"];
  static values = { url: String };

  connect() {
    // Defer to next tick so any Fomantic auto-init that happens on
    // turbo:load runs first; we then destroy and re-initialize with
    // our apiSettings overrides.
    queueMicrotask(() => this.initSearch());
  }

  disconnect() {
    $(this.element).find(".ui.search").search("destroy");
  }

  initSearch() {
    const controller = this;
    const $search = $(this.element).find(".ui.search");
    if ($search.length === 0) return;

    // Wipe any prior init so our settings actually take effect.
    if ($search.data("module-search")) {
      $search.search("destroy");
    }

    $search.search({
      minCharacters: 1,
      cache: false,
      apiSettings: {
        url: this.urlValue + "?q={query}",
        onResponse: (response) => {
          // Fomantic's $.api wraps arrays in indexed-key objects via
          // $.extend, and may hand us a string before parsing.
          let parsed = response;
          if (typeof parsed === "string") {
            parsed = JSON.parse(parsed || "[]");
          }
          let list = [];
          if (Array.isArray(parsed)) {
            list = parsed;
          } else if (parsed && typeof parsed === "object") {
            // {results: [...]} — pull through.
            if (Array.isArray(parsed.results)) {
              list = parsed.results;
            } else {
              // Indexed-object form like {"0": {...}, "1": {...}}.
              list = Object.values(parsed).filter(
                (v) => v && typeof v === "object"
              );
            }
          }
          return {
            success: true,
            results: list.map((r) => ({ title: r.name, id: r.id })),
          };
        },
      },
      fields: { title: "title" },
      onSelect(result) {
        if (controller.hasHiddenIdTarget) {
          controller.hiddenIdTarget.value = result.id;
        }
        if (controller.hasSubmitBtnTarget) {
          controller.submitBtnTarget.disabled = false;
          controller.submitBtnTarget.classList.remove("disabled");
          controller.submitBtnTarget.classList.add("primary");
        }
        return false;
      },
    });
  }
}
